/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationResponseData,
  GetOrganizationResponseDataFromJSON,
  GetOrganizationResponseDataFromJSONTyped,
  GetOrganizationResponseDataToJSON
} from './GetOrganizationResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationResponse
 */
export interface UpdateOrganizationResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationResponse
   */
  status?: number
  /**
   *
   * @type {GetOrganizationResponseData}
   * @memberof UpdateOrganizationResponse
   */
  data?: GetOrganizationResponseData
}

export function UpdateOrganizationResponseFromJSON(json: any): UpdateOrganizationResponse {
  return UpdateOrganizationResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetOrganizationResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationResponseToJSON(value?: UpdateOrganizationResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationResponseDataToJSON(value.data)
  }
}
